<ion-app [ngClass]="{ 'hide-toolbar': hideToolbar, 'hide-menu': hideMenu }">
  <ion-toolbar class="custom-toolbar">
    <div class="toolbar-wrapper">
    <div class="toolbar-left">
      <span class="gold-rate-label">
         <span class="desktop-label">Valore oro in tempo reale:</span>
         <span class="mobile-label">Oro:</span>
        <span [class.green]="valueUp" [class.red]="!valueUp">
          {{ goldValue | number: '1.2-2' }} €/gr
        </span>
        <span class="arrow-up">⬆️</span>
      </span>
    </div>
  
    <div class="toolbar-center">
      <ion-img src="assets/icon/MyGoldLogo.png" class="logo"></ion-img>
    </div>
  
    <div class="toolbar-right">
      <!-- <ion-button class="rounded-button" (click)="routeTo('deposito/vv')" fill="clear" style="text-transform: none;   font-weight: 755; --color:#835F08">Vendo oro</ion-button>
      <ion-button class="rounded-button" (click)="routeTo('deposito/r')" fill="clear" style="text-transform: none;   font-weight: 755; --color: #835F08">Riscatta oro</ion-button>       -->
      <div style="width: 30%" class="btn-inverse_standard" (click)="routeTo('deposito/vv')">Vendi <span class="only-desktop"> oro</span></div>
      <div style="width: 30%" class="btn-inverse_standard" (click)="routeTo('deposito/r')">Riscatta <span class="only-desktop"> oro</span></div>
      <ion-button [routerLink]="['/auth/profile']" fill="clear" class="icon-button">
        <ion-icon name="person-circle-outline" size="large"></ion-icon>
      </ion-button>
    </div>
  </div>
  </ion-toolbar>
  

  <ion-split-pane contentId="main-content">
    <ion-menu contentId="main-content" type="overlay" style="--border: none; max-width: 270px;">
      <ion-content style="top:20px">
        <ion-list id="inbox-list" style="margin-left: 10px;">
          <ion-menu-toggle auto-hide="false">
            <ion-item
              *ngFor="let p of appPages"
              routerDirection="root"
              [class.hidden]="!p.show"
              [routerLink]="[p.url]"
              [class.menu-active]="isActive(p.url)"
              (click)="p.click == null ? null : logout()"
              lines="none"
              detail="false"
              class="menu-item"
            >
              <ion-label>{{ p.title }}</ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>
      </ion-content>
    </ion-menu>

    <ion-router-outlet id="main-content" (activate)="onActivate($event)"></ion-router-outlet>
  </ion-split-pane>

  <div class="version-info">
    V.{{ version }}
  </div>
</ion-app>
